import { render } from "./Ocupacion.vue?vue&type=template&id=9890210c"
import script from "./Ocupacion.vue?vue&type=script&lang=js"
export * from "./Ocupacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__